import { Link } from "react-router-dom";
import type { Game } from "@/mocks/games";
import SectionHeader from "@/components/feature/SectionHeader";
import EmptyState from "@/components/base/EmptyState";
import { formatDate, getCategoryName } from "@/utils/gameUtils";
import { usePlay } from "@/components/feature/PlayProvider";

export default function HomeLatest({ games }: { games: Game[] }) {
  const { openPlay } = usePlay();

  return (
    <section aria-label="最新上架游戏">
      <SectionHeader
        eyebrow="保持上新"
        title="最新上架游戏"
        subtitle="按照上架时间倒序排列，第一时间体验刚上线的网页游戏。"
        moreTo="/search"
        moreLabel="查看最新"
      />
      {games.length > 0 ? (
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {games.map((game, index) => (
            <div
              key={game.id}
              className={`flex flex-col gap-4 p-4 transition hover:bg-background-100 sm:flex-row sm:items-center md:p-5 ${
                index !== games.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <Link to={`/detail/${game.id}`} className="flex shrink-0 items-center gap-4">
                <div className="h-20 w-16 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={game.cover}
                    alt={`${game.name} 封面`}
                    title={`${game.name} 网页游戏在线试玩`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-bold text-foreground-900 transition hover:text-primary-600 md:text-base">
                    {game.name}
                  </h3>
                  <div className="mt-1.5 flex flex-wrap items-center gap-2">
                    <span className="rounded-md bg-primary-100 px-2 py-0.5 text-[11px] font-bold text-primary-700">
                      {getCategoryName(game.category)}
                    </span>
                    <span className="text-xs text-foreground-500">{game.theme}</span>
                    <span className="flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-calendar-line"></i>
                      {formatDate(game.releaseDate)}
                    </span>
                  </div>
                </div>
              </Link>
              <p className="min-w-0 flex-1 text-sm leading-relaxed text-foreground-600 sm:pl-4">
                {game.summary}
              </p>
              <div className="flex shrink-0 items-center gap-2">
                <Link
                  to={`/detail/${game.id}`}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-2 text-sm font-medium text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
                >
                  详情
                </Link>
                <button
                  type="button"
                  onClick={() => openPlay(game)}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2 text-sm font-bold text-background-50 transition hover:bg-primary-600"
                >
                  <i className="ri-play-fill"></i>
                  试玩
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState icon="ri-time-line" title="暂无最新游戏" description="新游戏正在陆续上架，敬请期待。" />
      )}
    </section>
  );
}